module.exports = __webpack_public_path__ + "static/media/2-anatomy-of-the-facet-joints-01@3x.5552d896.jpg";